"use client";

import { useState } from "react";

type FAQItem = {
  question: string;
  answer: string;
};

const faqItems: FAQItem[] = [

  {
    question: "What is AGPSIRA?",
    answer:
      "AGPSIRA stands for Always Get Paid Share-In-Revenues Agreement. It is a business framework and automation platform that enables organizations and participants to collaborate through structured agreements and share in revenues generated by a Product, Service, or Experience (PSE)."
  },

  {
    question: "What is Share-In-Revenues (SiR)?",
    answer:
      "Share-In-Revenues (SiR) represents a participant's allocated share of revenues generated under an AGPSIRA Agreement."
  },

  {
    question: "Who is the PSE?",
    answer:
      "The Product, Service, or Experience (PSE) Owner is the individual or organization that owns, manages, or delivers the Product, Service, or Experience that generates revenue within an AGPSIRA Agreement."
  },

  {
    question: "Who is a Salesperson?",
    answer:
      "A Salesperson contributes to the generation of revenues by creating opportunities, introducing prospects, building relationships, developing customers, and supporting business growth."
  },

  {
    question: "What is a Business Service Provider (BSP)?",
    answer:
      "A Business Service Provider (BSP) is an individual, company, platform, agency, or organization that contributes services designed to help generate, support, increase, or sustain revenues within an AGPSIRA Agreement. Examples include Video Advertising Platforms, Display Advertising Platforms, Social Media Marketing Organizations, Influencers, SEO Providers, Sales Companies, Lead Generation Organizations, and Business Development Firms."
  },

  {
    question: "What is an External Account Holder (EAH)?",
    answer:
      "An External Account Holder (EAH) contributes expertise, influence, introductions, strategic relationships, advisory services, resources, funding, or industry knowledge that helps strengthen an AGPSIRA Agreement."
  },

  {
    question: "How are revenues distributed?",
    answer:
      "Revenues are distributed according to the percentages, allocations, and rules established within an AGPSIRA Agreement."
  },

  {
    question: "Do I need blockchain experience?",
    answer:
      "No. AGPSIRA is designed to provide a familiar web experience while blockchain technology operates behind the scenes."
  },

  {
    question: "Can participant allocations change?",
    answer:
      "Yes. Depending on agreement governance, authorized users may update participant structures, allocations, percentages, and fees."
  },

  {
    question: "How do participants receive distributions?",
    answer:
      "Participants receive Share-In-Revenues according to agreement rules and distribution schedules established within their AGPSIRA Agreement."
  }

];

export default function FAQPage() {

  const [openIndex, setOpenIndex] =
    useState<number | null>(0);

  function toggleSection(
    index: number
  ) {

    setOpenIndex(
      openIndex === index
        ? null
        : index
    );

  }

  return (

    <main className="min-h-screen bg-slate-950 text-white">

      <section className="max-w-6xl mx-auto px-4 md:px-8 py-20">

        <h1 className="text-4xl md:text-6xl font-bold text-center mb-6">
          Frequently Asked Questions
        </h1>

        <p className="text-center text-slate-300 text-lg max-w-4xl mx-auto mb-16">
          Learn more about AGPSIRA,
          Share-In-Revenues (SiR),
          participant roles,
          distributions,
          and agreements.
        </p>

        <div className="space-y-4">

          {faqItems.map((item, index) => {
            const isOpen = openIndex === index;

            return (

              <div
                key={item.question}
                className="rounded-2xl border border-slate-800 bg-slate-900"
              >

                <button
                  type="button"
                  className="flex w-full items-center justify-between gap-6 px-6 py-5 text-left"
                  aria-expanded={isOpen}
                  onClick={() => toggleSection(index)}
                >
                  <span className="text-lg font-semibold">
                    {item.question}
                  </span>
                  <span
                    aria-hidden="true"
                    className="text-2xl text-slate-400"
                  >
                    {isOpen ? "−" : "+"}
                  </span>
                </button>

                {isOpen && (
                  <div className="border-t border-slate-800 px-6 py-5">
                    <p className="leading-8 text-slate-300">
                      {item.answer}
                    </p>
                  </div>
                )}

              </div>

            );
          })}

        </div>

      </section>

    </main>

  );

}